var indentStyle = {"indentZero":"plW2a","indentOne":"_2UBIT","indentTwo":"HzrSi","indentThree":"H8gqk","indentFour":"_87xRf","indentFive":"nFNhC","indentSix":"OaHyw"};

export { indentStyle as i };
//# sourceMappingURL=indentation-19e8fed2.js.map
